// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-wrapper--GJoKl{padding:20px 31px}", "",{"version":3,"sources":["webpack://./src/components/common/HistoryCard/history.module.scss"],"names":[],"mappings":"AAAA,oBACE,iBAAA","sourcesContent":[".tab-wrapper {\n  padding: 20px 31px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-wrapper": "tab-wrapper--GJoKl"
};
export default ___CSS_LOADER_EXPORT___;
